// src/App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';

import ListPage from './components/listPage/index.tsx';
import { baseApi } from './services/solutionAPI.ts';
import {
  ProposalShellNew,
  ProposalShellDetail,
} from './components/proposal/ProposalShell.tsx';

const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export default function App() {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          {/* 新規作成（Seeds を初期表示） */}
          <Route path="/proposals/new" component={ProposalShellNew} />
          {/* 詳細（Seeds を初期表示） ※new より後に置く */}
          <Route path="/proposals/:sessionId" component={ProposalShellDetail} />
          {/* 既存ページ */}
          <Route exact path="/" component={ListPage} />
        </Switch>
      </Router>
    </Provider>
  );
}